/* eslint-disable react-hooks/exhaustive-deps */

import {
  IAddress,
  IMember,
  INewUser
} from "@wingspanhq/users/dist/lib/interfaces";
import { useEffect } from "react";
import { useUserId } from "../query/hooks/helpers";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../query/users/queries";
import { identifyWithCommonFields, page } from "./analytics";

export const useIdentify = () => {
  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId, { enabled: !!userId });
  const queryMember = useQueryMemberProfile(userId, { enabled: !!userId });

  const user = queryUser.data;
  const member = queryMember.data;

  useEffect(() => {
    if (!!user && !!member) {
      identify(user, member);
    }
  }, [
    !!user,
    !!member,
    user?.intercomUserHash,
    user?.intercomUserJwt,
    member?.profile?.homeAddress,
    member?.profile?.address,
    member?.profile?.company
  ]);
};

function identify(user: INewUser, member: IMember) {
  if (!window.userEmail) {
    window.userEmail = user.email as string;
    page();
  }

  window.intercomUserHash = user.intercomUserHash;
  window.intercomUserJwt = user.intercomUserJwt;

  const ownerIds = user.userRoles?.ownerIds;
  const formattedOwnerIds =
    ownerIds && ownerIds.length > 0 ? ownerIds.join("-") : undefined;

  const getValidAddress = (address?: IAddress) => {
    if (
      address?.addressLine1 &&
      address?.city &&
      address?.state &&
      address?.postalCode &&
      address?.country
    ) {
      return {
        street: address.addressLine2
          ? `${address.addressLine1}, ${address.addressLine2}`
          : address.addressLine1,
        city: address.city,
        state: address.state,
        postalCode: address.postalCode,
        country: address.country
      };
    }
    return undefined;
  };

  const formattedAddress =
    getValidAddress(member.profile?.homeAddress) ||
    getValidAddress(member.profile?.address);

  const company = member.profile?.company;
  const companyName =
    (company as any)?.doingBusinessAs ||
    company?.legalBusinessName ||
    company?.name;

  identifyWithCommonFields(user.userId, {
    email: user.email,
    intercomUserHash: user.intercomUserHash,
    ownerIds: formattedOwnerIds,
    address: formattedAddress,
    website: company?.website || company?.links?.websiteUrl,
    companyName: companyName,
    legalBusinessName: company?.legalBusinessName,
    phone: user.phone?.number
  });
}
